import type { Segment } from '../../migrations/legacyEdge';

export type OperatorKind = 'normal' | 'branch' | 'loop' | 'fail' | 'parallel' | 'wait';

export const OPERATOR_BADGE: Record<OperatorKind, string> = {
  branch: 'IF',
  loop: 'WHILE',
  fail: 'TRY',
  parallel: 'PAR',
  wait: 'WAIT',
  normal: 'STEP',
};

const OPERATOR_COLOR_VARIANTS: Record<string, Record<OperatorKind, string>> = {
  subtle: {
    branch: '#4a7fb5',
    loop: '#9b59b6',
    fail: '#c0392b',
    parallel: '#4a7fb5',
    wait: '#9b59b6',
    normal: '#aaa',
  },
  vivid: {
    branch: '#4a7fb5',
    loop: '#9b59b6',
    fail: '#c0392b',
    parallel: '#2f8f83',
    wait: '#8b6f2a',
    normal: '#8e8679',
  },
};

export const FLOW_LABEL: Record<OperatorKind, string> = {
  normal: '',
  branch: 'bifurca',
  loop: 'bucle',
  fail: 'fallo',
  parallel: 'paralelo',
  wait: 'espera',
};

export function getSegmentOperator(seg: Segment): OperatorKind {
  return (seg.flowType ?? 'normal') as OperatorKind;
}

export function getOperatorColor(seg: Segment, variant: 'subtle' | 'vivid' = 'subtle') {
  const palette = OPERATOR_COLOR_VARIANTS[variant] ?? OPERATOR_COLOR_VARIANTS.subtle;
  return palette[getSegmentOperator(seg)] ?? palette.normal;
}

export function formatHeaderLabel(seg: Segment) {
  const op = getSegmentOperator(seg);
  const cond = seg.condition?.trim();
  if (op === 'branch') return `IF ${cond || 'condición'}`;
  if (op === 'loop') return `WHILE ${cond || 'condición'}`;
  if (op === 'fail') return 'TRY';
  
  return undefined;
}
